export const SALESFORCE_DIVISIONS = {
    ADMINISTRACAO: 1,
    ASSISTENCIA_TECNICA: 2,
    CRC: 3,
    ENTREGA_DE_CHAVES: 4,
    FINANCEIRO: 5,
    JURIDICO: 6,
    PERSONALIZAÇÃO: 7,
    PROJETOS: 8,
    SECRETARIA_DE_VENDAS: 9,
  };